import { integerValue } from '~/utils';

const onlyCpfCnpj = value => /^(\d{1,14})$/g.test(integerValue(value)) || value === '';

export default onlyCpfCnpj;
